
import { CompanyGoToHelper } from "@/lib/utility/company.go-to-helper";
import { CompanyGroup, ICompanyGroup } from "@/models/company-group.entity";
import { ICompany } from "@/models/company.entity";
import { CompanyGroupModule } from "@/store/modules/company-group.store";
import { Component, Prop, Watch } from "vue-property-decorator";
import BaseRef from "./BaseRef.vue";
import { IRefDetail } from "./RefsList.vue";

@Component({
  components: {},
  filters: {}
})
export default class RefsCompany extends BaseRef<ICompany> implements IRefDetail<ICompany> {
  @Prop()
  item!: ICompany;

  @Prop()
  small!: boolean;

  @Prop({ default: true })
  showCompany!: boolean;

  @Prop()
  confirmable!: boolean;

  group: ICompanyGroup | null = null;

  loadingProject = false;

  get isLoading() {
    return this.item?.loading;
  }

  async mounted() {
    await this.setGroup();
  }

  async goToDetail() {
    const partnerId = this.item.partnerId;
    const companyId = this.item.id;
    const newTab = false;

    new CompanyGoToHelper(this.$router).goToCompanyDetail({ companyId, partnerId, newTab });
  }

  @Watch("item.groupId")
  async setGroup() {
    try {
      if (this.item.groupId) {
        this.loadingProject = true;
        let group = CompanyGroupModule.maps.id.get(this.item.groupId)[0];
        if (!group) {
          group = await new CompanyGroup({ partnerId: this.item.partnerId, id: this.item.groupId }).fetch();
        }
        this.group = group;
      }
    } catch (e) {
      this.$log.error(e);
    } finally {
      this.loadingProject = false;
    }
  }

  goToCompanyGroupCustomView() {
    if (!this.item.groupId) return;

    new CompanyGoToHelper(this.$router).goToCompanyGroupCustomView({
      partnerId: this.item.partnerId,
      companyGroupId: this.item.groupId,
      viewId: "0",
      newTab: true
    });
  }
}
